import React from "react";
import { useNavigate } from "react-router-dom";

const OurCapabilitiesSection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="w-full bg-[#0b4864]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-10 sm:pb-12">

        {/* Image + Overlay Banner */}
        <div className="relative flex justify-center">
          {/* Overlay banner */}
          <div className="absolute top-5 z-10 w-full px-4">
            <div className="bg-[#d8e6ee] py-3 text-center rounded-md shadow-sm">
              <p className="font-semibold text-[#0b4864] text-sm sm:text-base">
                Modern branding solutions designed to strengthen your online
                presence
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="w-full max-w-2xl overflow-hidden rounded-lg">
            <img
              src="/assets/capabilities-meeting.webp"
              alt="Team meeting discussing strategy"
              className="w-full object-cover aspect-[16/9]"
              loading="lazy"
            />
          </div>
        </div>

        {/* Content */}
        <div className="mt-12 sm:mt-14">
          <h2 className="text-white font-bold text-2xl sm:text-3xl">
            Our Capabilities
          </h2>

          <p className="mt-4 max-w-5xl text-white/90 text-sm sm:text-base leading-7 sm:leading-8">
            Digital Transformation Associates is widely acknowledged for its
            strong growth, deep industry expertise, and unwavering commitment to
            client success. We deliver end-to-end business consulting across the
            supply chain, comprehensive IT implementation services, advanced
            data and analytics solutions, and reliable application management
            support. At DTA, we approach every challenge with ownership, treating
            our clients’ business needs as our own. Our solutions are designed
            to drive efficiency, innovation, and measurable results. Explore the
            areas below to learn how our capabilities can enhance and transform
            every stage of your supply chain operations.
          </p>

          {/* CTA */}
          <div className="mt-6">
            <div
             onClick={()=>navigate("/services")}
              className="inline-flex items-center justify-center rounded-md bg-white px-6 py-3 text-sm font-semibold text-[#0b4864] transition hover:bg-white/90"
            >
              Our Services
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurCapabilitiesSection;
